import React from 'react';
import { Link } from 'react-router-dom';

const Page404 = () => {
    return (
        <div>
            <section className="bg-white">
                <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                    <div className="mx-auto max-w-screen-sm text-center">
                        <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-slate-600">404</h1>
                        <p className="mb-4 text-3xl tracking-tight font-bold text-red-600 md:text-4xl ">Hata</p>
                        <p className="mb-4 text-lg font-light text-gray-500 ">Üzgünüz, ulaşmaya çalıştığınız dayfayı bulamadık. Ana sayfaya dönmeyi deneyiniz. </p>
                        <Link to="/" className="inline-flex text-slate-500 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">Anasayfa</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Page404;
